// extracted by mini-css-extract-plugin
module.exports = {"outer":"outer___3dM4P"};